import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core"
import { DropDownItem, DropDownType } from "../flow-drop-down.component"

@Component({
  selector: "flow-drop-down-item",
  templateUrl: "./flow-drop-down-item.component.html",
  styleUrl: "./flow-drop-down-item.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlowDropDownItemComponent {
  @Input({ required: true }) public item!: DropDownItem
  @Input({ required: true }) public type!: DropDownType
  @Input() public highlightSelected = false
  @Input() public isSelected = false

  @Output() public selected = new EventEmitter<void>()

  public get highlighted(): boolean {
    return this.highlightSelected && this.isSelected && !this.showsControl
  }

  private get showsControl(): boolean {
    return this.type === "item" && this.item.checkbox !== "none"
  }
}
